import { AuditCriteriaMapStatus } from '@/store/modules/audits/types/audits.types';
import {
  CplusCriteria,
  JBICriteriaDTO,
} from '@/store/modules/projects/types/projects.types';

export const transformCriteriaIntoCplusDTO = (
  criteriaList: any[],
  updatedJBICriteriaList: JBICriteriaDTO[],
  isProjectLevel: boolean,
): CplusCriteria[] => {
  if (!criteriaList.length) {
    return [];
  }
  const dirtyCriteriaArray: CplusCriteria[] = [];
  criteriaList.forEach((criteriaDto) => {
    /** here criteriaDto is ProjectCriteria for project level and auditCriteriaMap for audit level */
    const criteria = isProjectLevel ? criteriaDto : criteriaDto.criteria;
    const isCriteriaActive =
      criteriaDto.isDeleted === false ||
      criteriaDto.status === AuditCriteriaMapStatus.ACTIVE;

    if (isProjectLevel && criteria.isDeleted === true) {
      return;
    } else if (!isProjectLevel && !isCriteriaActive) {
      return;
    }

    const transformedCriteria: CplusCriteria = {
      id: criteria.id,
      title: criteria.title,
      type: criteria.criteriaType,
      criteriaOptions: JSON.parse(criteria.criteriaOptions).filter(
        (option: any) => {
          return option !== 'N/A';
        },
      ),
      booleanOptions: JSON.parse(criteria.criteriaOptions),
      range: JSON.parse(criteria.criteriaOptions),
      checkboxesOptions: JSON.parse(criteria.criteriaOptions),
      continuousDiscreteOptions: JSON.parse(criteria.criteriaOptions),
      document: {
        id: criteria.documentId,
        title: criteria.documentName,
        description: criteria.description,
      },
      guide: criteria.guide,
      tags: getTags(criteria.criteriaTags),
      bestPracticeRecommendations: [],
      criteriaDetails: criteria,
      /** here criteriaDto is ProjectCriteria for project level and auditCriteriaMap for audit level */
      order: isProjectLevel ? criteria.order : criteriaDto.order,
      sourceLink: criteria.sourceLink,
      isChanged: criteria.isChanged,
      config: criteria.config,
      auditCycles: criteria.auditCycles,
    };
    if (updatedJBICriteriaList && updatedJBICriteriaList.length > 0) {
      updatedJBICriteriaList.forEach((updatedJbiCriteria: JBICriteriaDTO) => {
        if (
          updatedJbiCriteria.connectPlusCriteriaId === +criteria.connectPlusId
        ) {
          transformedCriteria.updatedJbiCriteria = updatedJbiCriteria;
        }
      });
    }
    dirtyCriteriaArray.push(transformedCriteria);
  });

  return dirtyCriteriaArray;
};

export const getTags = (tagsInfo: any) => {
  const tags: string[] = [];
  if (tagsInfo === undefined) {
    return tags;
  }
  Object.keys(tagsInfo).forEach((key: string) => {
    const tag = tagsInfo[key];
    tag.forEach((tagVal: any) => {
      tags.push(tagVal.tag);
    });
  });
  return tags;
};
